'use client'

import { TrendingUp } from 'lucide-react'
import {
  AreaChart,
  CartesianGrid,
  Area,
  LineChart,
  XAxis,
  YAxis,
} from 'recharts'

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import type { DataItem } from './types'

export interface FeatureLineChartProps {
  dataset?: DataItem[]
  title?: string
  description?: string
  valueLabel?: string
}

export default function FeatureLineChart(props: FeatureLineChartProps) {
  const { dataset, title, description, valueLabel = 'Value' } = props

  const chartConfig = {
    date: {
      label: 'Date',
      color: '#FFD700',
    },
    value: {
      label: valueLabel,
      color: '#FFD700',
    },
  } as ChartConfig

  return (
    <Card className="bg-white/10">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={chartConfig}
          style={{ height: '400px', width: '100%' }}
        >
          <AreaChart
            accessibilityLayer
            data={dataset}
            margin={{
              left: 24,
              right: 12,
              top: 12,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value) => value}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickCount={5}
              domain={[
                0,
                (dataMax: number) => Math.max(5, Math.ceil(dataMax * 1.5)),
              ]}
              tickFormatter={(value) => (Number.isInteger(value) ? value : '')}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel nameKey="value" />}
            />
            <Area
              dataKey="value"
              type="linear"
              fill="#FFD700"
              stroke="#FFD700"
              strokeWidth={2}
              fillOpacity={0.15}
            />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
